"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var client_lib_js_player_framework_utils_1 = require("@sky-uk-ott/client-lib-js-player-framework-utils");
var WebMafBridge = (function () {
    function WebMafBridge(context) {
        var _this = this;
        this.emitter = new client_lib_js_player_framework_utils_1.EventEmitter();
        this.webMafWindow = context.top;
        this.ensureWebMafIsAvailable();
        this.webMafWindow.accessfunction = function (rawData) {
            var data = client_lib_js_player_framework_utils_1.safeParse(rawData);
            if (data && data.command) {
                _this.emitter.emit(data.command, data);
            }
            else {
                _this.emitter.emit('unknown', rawData);
            }
        };
    }
    WebMafBridge.prototype.sendCommand = function (command, options) {
        var commandObject = options ? Object.assign({ command: command }, options) : { command: command };
        var commandString = JSON.stringify(commandObject);
        this.webMafWindow.external.user(commandString);
    };
    WebMafBridge.prototype.listenToEvent = function (event, listener, listenOnceOnly) {
        if (listenOnceOnly) {
            this.emitter.once(event, listener);
        }
        else {
            this.emitter.on(event, listener);
        }
    };
    WebMafBridge.prototype.getDevSettings = function () {
        return {
            version: this.webMafWindow.WM_devSettings.version,
        };
    };
    WebMafBridge.prototype.getFileApi = function () {
        return {
            write: this.webMafWindow.WM_File.write,
            read: this.webMafWindow.WM_File.read,
        };
    };
    WebMafBridge.prototype.ensureWebMafIsAvailable = function () {
        if (!this.webMafWindow.WM_File) {
            throw new Error('WebMAF storage API is unavailable');
        }
    };
    return WebMafBridge;
}());
exports.WebMafBridge = WebMafBridge;
